import React, { forwardRef } from 'react'
import Spinner from '../Spinner'

export default forwardRef(function Submit(props, ref) {
  const {
    color = 'blue',
    children,
    className,
    divClassName,
    isLoading,
    disabled,
    text,
    type = 'submit',
    ...rest
  } = props

  return (
    <div className={divClassName} ref={ref}>
      <button
        type={type}
        {...rest}
        disabled={disabled || isLoading}
        className={[
          'btn flex items-center justify-center',
          color && `btn-${color}`,
          className,
          disabled && 'opacity-50',
        ]}
        >
        {isLoading && (
          <Spinner color="white" height="1.5em" className="absolute" />
        )}
        <span className={[isLoading && 'opacity-0']}>
          {text || children}
        </span>
      </button>
    </div>
  )
})
